import { ProductSuitabilityOption } from './ProductSuitability.enum';
import type { IProductSuitability } from './ProductSuitability.interface';

export default class ProductSuitability implements IProductSuitability {
  isUnsuitable: ProductSuitabilityOption;
  isProductInconsistent: boolean;
  isApplicantComply: boolean;

  static build = (data: IProductSuitability) => new ProductSuitability(data);
  static blank = () => new ProductSuitability();

  /**
   * Constructor
   * @param {IProductSuitability} data
   */
  constructor(data?: IProductSuitability) {
    this.isUnsuitable = ProductSuitabilityOption.of(data?.isUnsuitable?.name);
    this.isProductInconsistent = data?.isProductInconsistent === true;
    this.isApplicantComply = data?.isApplicantComply === true;
  }
}
